import _orderBy from 'lodash/orderBy';

import { State, Cooperative } from 'models';
import { createDeepEqualSelector } from '../helpers';
import { currentCooperativeSelector } from '../settings/selectors';

function isRescuePlanPageVisible(cooperative: Cooperative) {
  return !!cooperative.RescuePlanLink;
}

function sortCooperatives(cooperatives: Cooperative[]) {
  return _orderBy(cooperatives, (cooperative) => cooperative.Name, 'asc');
}

export const getCooperatives = (state: State) =>
  sortCooperatives(state.home.cooperatives);
export const getCooperativeId = (state: State) =>
  state.settings.current_cooperative;
const menuConfigSelector = (state: State) => state.home.menuConfig;

export const getCurrentCooperative = createDeepEqualSelector(
  currentCooperativeSelector,
  getCooperatives,
  (currentCoopreative, cooperatives) => {
    return cooperatives.find(
      (cooperative) => cooperative.Id === currentCoopreative
    );
  }
);

const selectProccessedMenuConfig = createDeepEqualSelector(
  menuConfigSelector,
  getCurrentCooperative,
  (menuConfig, cooperative) =>
    cooperative
      ? menuConfig.filter((menuItem) =>
          menuItem.Id === 'rescue-plan'
            ? isRescuePlanPageVisible(cooperative)
            : true
        )
      : []
);

export const getMenuConfig = createDeepEqualSelector(
  selectProccessedMenuConfig,
  (menuConfig) => _orderBy(menuConfig, ['Order'], 'asc')
);
